import './label-group.css';
export default {
  "button": "pf-v6-c-button",
  "labelGroup": "pf-v6-c-label-group",
  "labelGroupClose": "pf-v6-c-label-group__close",
  "labelGroupLabel": "pf-v6-c-label-group__label",
  "labelGroupList": "pf-v6-c-label-group__list",
  "labelGroupListItem": "pf-v6-c-label-group__list-item",
  "labelGroupMain": "pf-v6-c-label-group__main",
  "labelGroupTextarea": "pf-v6-c-label-group__textarea",
  "modifiers": {
    "category": "pf-m-category",
    "vertical": "pf-m-vertical",
    "editable": "pf-m-editable",
    "textarea": "pf-m-textarea"
  }
};